<template>
  <div class="image-player" @contextmenu.prevent>
    <img
      ref="thumbnail"
      :src="mediaPath"
      :class="center ? '' : 'normal'"
      @click.stop="lookBigPicture" />

    <div
      class="image-mask"
      :class="showBigPicture ? 'show' : ''"
      @click.self.stop="closeBigPicture">
      <img
        :src="mediaPath"
        :style="{ top: `${originPageY}px`, left: `${originPageX}px` }" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImagePlayer',
  props: {
    center: { type: Boolean, default: true },
    mediaPath: { type: String, required: true },
  },
  data() {
    return {
      originPageX: 0,
      originPageY: 0,
      showBigPicture: false,
    };
  },
  methods: {
    lookBigPicture() {
      this.showBigPicture = true;
    },
    closeBigPicture() {
      this.showBigPicture = false;
    },
  },
  mounted() {
    const { x, y } = this.$refs.thumbnail.getBoundingClientRect();

    this.originPageX = x;
    this.originPageY = y;
  },
};
</script>

<style lang="less" scoped>
.image-player {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 180px;
  overflow: hidden;

  > img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    height: 100%;
    border-radius: 4px;
    cursor: pointer;

    &.normal {
      top: 0;
      left: 0;
      transform: none;
    }
  }

  > .image-mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 2000;
    background-color: rgba(0, 0, 0, .6);
    opacity: 0;
    pointer-events: none;
    transition: all .32s linear;

    &.show {
      opacity: 1;
      pointer-events: visible;

      > img {
        top: 50% !important;
        left: 50% !important;
        transform: translateX(-50%) translateY(-50%);
        height: 40vh;
      }
    }

    > img {
      position: absolute;
      height: 180px;
      transition: all .32s linear;
    }
  }
}
</style>
